import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NavController, NavParams } from '@ionic/angular';
import { RilevazionePresenzeService } from '../services/rilevazione-presenze-service';

import { Studente } from '../models/didattica/studente';
import { AbstractPage } from '../AbstractPage';
import { LoadingController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Rilevazione } from '../models/rilevazione-presenze/rilevazione';
import { UtilityService } from '../services/utility.service';
import { Presenza, StatoPresenza } from '../models/rilevazione-presenze/presenza';
import { ConfermaPresenza } from '../models/rilevazione-presenze/conferma-presenza';
import { ConfigService } from '../services/config-service/config-service';
import { UserService } from '../services/user-service';
import { ChiaveConfig } from '../models/configurazioni/ChiaveConfig';
@Component({
    selector: 'app-manage-presenza',
    templateUrl: './manage-presenza.page.html',
    styleUrls: ['./manage-presenza.page.scss'],
    standalone: false
})
export class ManagePresenzaPage extends AbstractPage implements OnInit {
  formValido = false;
  form: FormGroup;
  studente: Studente;
  studenti: Studente[] = [];
  notFound = false;
  rilevazione: Rilevazione;
  startDate: string;
  startDatePicked;
  endDate: string;
  endDatePicked;
  cpDate: string;
  cpDatePicked;
  presenza: Presenza;

  assenza = false;
  giustificata = false;
  abuso = false;
  segnalaUscitaAnticipata = false;
  registraConfermaPresenza = false;
  showSearch = true;

  cdsList = this.configService.getConfigurazione(ChiaveConfig.CDS_LIST_REDUCED_HOURS).split(",");

  constructor(
    public navCtrl: NavController,
    public router: Router,
    public route: ActivatedRoute,
    private loadingCtrl: LoadingController,
    private translateService: TranslateService,
    public modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private rilevazionePresenzeService: RilevazionePresenzeService,
    public navParams: NavParams,
    private utilityService: UtilityService,
    public configService: ConfigService,
    public userService: UserService
  ) {
    super(navCtrl, router);
    this.rilevazione = this.navParams.data.rilevazione;

    this.presenza = this.navParams.data.presenza;
    if (this.presenza) {
      this.studente = this.presenza.studente;
      this.showSearch = false;
      if (this.presenza.stato === StatoPresenza.ASSENZA) {
        this.assenza = true;
        this.giustificata = this.presenza.giustificata;
      }
      if (this.presenza.stato === StatoPresenza.ABUSO) {
        this.abuso = true;
      }
      if (this.presenza.giustificata) {
        this.giustificata = true;
      }
    }

    if (this.presenza) {
      this.startDate = this.utilityService.setLocalTime(this.presenza.istanteMarcatura).toISOString();
      this.endDate = undefined;
      if (this.presenza.istanteUscita) {
         this.endDate = this.utilityService.setLocalTime(this.presenza.istanteUscita).toISOString();
      }
    } else {
      this.startDate = this.utilityService.setLocalTime(this.rilevazione.istanteCreazione).toISOString();
      if (this.rilevazione.chiusura) {
        this.endDate = this.utilityService.setLocalTime(this.rilevazione.chiusura).toISOString();
      }
    }
    if (!this.endDate) {
      this.segnalaUscitaAnticipata = false;
    } else {
      this.segnalaUscitaAnticipata = true;
    }

    if (this.rilevazione.richiestaConferma) {
      this.cpDate = this.utilityService.setLocalTime(this.rilevazione.richiestaConferma.istanteRichiesta).toISOString();
      if (this.presenza && this.presenza.confermaPresenza) {
        this.cpDate = this.utilityService.setLocalTime(this.presenza.confermaPresenza.istanteConferma).toISOString();
        this.registraConfermaPresenza = true;
      } else {
        this.registraConfermaPresenza = false;
      }
    }

    // definizione dei campi del form
    this.form = this.formBuilder.group({
      matricola: [
        '',
        Validators.compose([
          Validators.maxLength(20),
          Validators.pattern('[a-zA-Z0-9-/ ]*'),
          Validators.required

        ])
      ]
    });
    this.form.valueChanges.subscribe(v => {
      this.formValido = this.form.valid;
    });
    this.notFound = false;
  }

  ngOnInit() {
    console.log('ngOnInit ManagePresenzaPage');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ManagePresenzaPage');
  }

  registraUscitaAnticipata() {
    console.log('segnalaUscitaAnticipata', this.segnalaUscitaAnticipata);
    if (this.segnalaUscitaAnticipata) {
      if (this.presenza && this.presenza.istanteUscita) {
        this.endDate = this.utilityService.setLocalTime(this.presenza.istanteUscita).toISOString();
      } else {
        if (this.rilevazione.chiusura) {
          this.endDate = this.utilityService.setLocalTime(this.rilevazione.chiusura).toISOString();
        }
      }
    } else {
      this.endDate = undefined;
    }
  }

  segnalaAssenza() {
    if (!this.assenza) {
      this.giustificata = false;
    }
  }

  registraConferma() {
    console.log('registraConferma', this.registraConfermaPresenza);
    if (this.registraConfermaPresenza) {
      if (this.presenza && this.presenza.confermaPresenza) {
        this.cpDate = this.utilityService.setLocalTime(this.presenza.confermaPresenza.istanteConferma).toISOString();
      } else {
        if (this.rilevazione.richiestaConferma) {
           this.cpDate = this.utilityService.setLocalTime(this.rilevazione.richiestaConferma.istanteRichiesta).toISOString();
        }
      }
    } else {
      this.cpDate = undefined;
    }
  }

  async cerca() {
    this.studente = undefined;
    this.studenti = [];
    this.notFound = false;
    this.segnalaUscitaAnticipata = false;

    const loader = await this.loadingCtrl.create({
      message: this.translateService.instant('label.richiestaincorso')
    });
    loader.present();
    console.log('matricola ' + this.form.value.matricola);
    this.rilevazionePresenzeService
      .cercaStudenteCarriere(this.form.value.matricola)
      .subscribe(
        studenti => {
          loader.dismiss();
          if (studenti && studenti.length > 0) {
            if (studenti.length === 1) {
              this.studente = studenti[0];
              this.showSearch = false;
            } else {
              this.studenti = studenti;
            }
          } else {
            this.notFound = true;
          }
        },
        error => {
          loader.dismiss();
          throw error;
        }
      );
  }

  selezionaCarriera(studente: Studente) {
    this.studente = studente;
    this.studenti = [];
    this.showSearch = false;
  }

  conferma() {
    let complete = false;
    let doDateCheck = true;
    let stato = StatoPresenza.PRESENZA;
    const giustificata = this.giustificata;

    if(this.rilevazione.ar.cds.length !== 0) {
      if(this.configService.getConfigurazione(
        ChiaveConfig.VAL_ORE_ACCADEMICHE) !== 60 &&
        this.cdsList.includes(this.rilevazione.ar.cds[0].id) && this.rilevazione.durata >= 60) {
          let timeDiff = new Date((new Date(this.startDatePicked).getTime() - new Date(this.rilevazione.istanteCreazione).getTime())).getMinutes();

          if((this.rilevazione.durata - timeDiff) <= 
          (this.rilevazione.durata - this.configService.getConfigurazione(ChiaveConfig.VAL_ORE_ACCADEMICHE))) {
            this.utilityService.presentToast(this.translateService.instant('manage-presenza.error.academicTime'));
            return;
          }
        }
    }

    if (this.assenza) {
      stato = StatoPresenza.ASSENZA;
      doDateCheck = false;
      complete = true;
    }
    if (this.abuso) {
      stato = StatoPresenza.ABUSO;
    }

    let locIstanteMarcatura;
    if (stato !== StatoPresenza.PRESENZA) {
      locIstanteMarcatura = new Date(this.rilevazione.istanteCreazione);
    } else {
        locIstanteMarcatura = this.utilityService.setUTCTime(this.startDate);
      if (this.startDatePicked) {
        locIstanteMarcatura = new Date(this.startDatePicked);
      }
    }

    let locIstanteUscita;
    if (this.segnalaUscitaAnticipata) {
      if (stato === StatoPresenza.ASSENZA) {
        locIstanteUscita = new Date(this.rilevazione.istanteCreazione);
      } else {
        if (this.endDatePicked) {
          locIstanteUscita = new Date(this.endDatePicked);
        } else {
          if (this.endDate) {
            locIstanteUscita = this.utilityService.setUTCTime(this.endDate);
          }
        }
      }
    }

    if (doDateCheck) {
      const datemessage = this.utilityService.checkDates(locIstanteMarcatura, locIstanteUscita, this.rilevazione);
      complete = datemessage === undefined;
      if (!complete) {
        this.utilityService.presentToast(datemessage);
        return;
      }
    }

    const p: Presenza = {
      id: this.presenza ? this.presenza.id : undefined,
      idRilevazione: this.rilevazione.id,
      idStudente: this.studente.id,
      matricola: this.studente.matricola,
      istanteMarcatura: locIstanteMarcatura,
      stato: stato,
      giustificata: giustificata,
      istanteUscita: locIstanteUscita
    };


    let cp: ConfermaPresenza;
    let locIstanteConferma;

    if (this.registraConfermaPresenza) {
      locIstanteConferma = new Date(this.rilevazione.richiestaConferma.istanteRichiesta);
      if (this.presenza && this.presenza.confermaPresenza) {
        locIstanteConferma = new Date(this.presenza.confermaPresenza.istanteConferma);
      }
      if (this.cpDatePicked) {
        locIstanteConferma = new Date(this.cpDatePicked);
      }
    }

    if (doDateCheck && locIstanteConferma) {
        complete = this.utilityService.dataConfermaCoerente(locIstanteConferma, this.rilevazione);
        if (!complete) {
          this.utilityService.presentToast(this.translateService.instant('manage-presenza.error.invalidcpdate'));
          return;
        }
        cp = {
          richiestaConferma: this.rilevazione.richiestaConferma,
          idStudente: this.presenza ? this.presenza.idStudente : this.studente.id,
          idRilevazione: this.rilevazione.id,
          istanteConferma: locIstanteConferma
        };
    }
    p.confermaPresenza = cp;
    this.modalCtrl.dismiss({presenza: p});
  }


  getTime(kind: string, event) {
    console.log('event', event);
    if (!event) {
      return;
    }
    console.log('event', event.detail.value);
    if (kind === 'start') {
      this.startDatePicked = event.detail.value;
    }
    if (kind === 'end') {
      this.endDatePicked = event.detail.value;
    }
    if (kind === 'cp') {
      this.cpDatePicked = event.detail.value;
    }
  }
  cancel() {
    this.modalCtrl.dismiss();
  }
}
